import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils/general"

const badgeVariants = cva(
  "inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-favorit-mono transition-colors ",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-white/10 text-white/90",
        secondary:
          "border-transparent bg-white/5 text-white/70",
        destructive:
          "border-transparent bg-destructive/20 text-destructive shadow",
        outline: "text-white/80 border-white/20",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
